import React from 'react';
import Joyride, { CallBackProps, STATUS } from 'react-joyride';
import { useTheme } from '../ThemeProvider';
import { useTour } from '../../context/TourContext';
import { dashboardSteps } from './dashboardSteps';

const DashboardTour: React.FC = () => {
  const { theme } = useTheme();
  const { runDashboardTour, stopPageTour } = useTour();

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action } = data;

    // Handle close button or tour completion
    if (action === 'close' || status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      stopPageTour('dashboard');
    }
  };

  return (
    <Joyride
      steps={dashboardSteps}
      run={runDashboardTour}
      continuous
      showProgress
      showSkipButton
      disableOverlayClose={false}
      disableCloseOnEsc={false}
      hideCloseButton={false}
      spotlightClicks={true}
      scrollToFirstStep={true}
      disableScrolling={false}
      scrollOffset={100}
      scrollDuration={300}
      callback={handleJoyrideCallback}
      floaterProps={{
        disableAnimation: false,
        options: {
          preventOverflow: {
            boundariesElement: 'viewport',
          },
        },
        styles: {
          floater: {
            filter: 'none'
          }
        }
      }}
      styles={{
        options: {
          zIndex: 10000,
        },
        tooltip: {
          backgroundColor: theme === 'dark' ? 'hsl(220 13% 9%)' : '#fff',
          color: theme === 'dark' ? 'hsl(210 40% 98%)' : '#000',
          fontSize: 14,
          padding: 20,
          borderRadius: 8,
        },
        tooltipContainer: {
          textAlign: 'left'
        },
        buttonNext: {
          backgroundColor: theme === 'dark' ? 'hsl(210 40% 98%)' : 'hsl(222 29% 16%)',
          color: theme === 'dark' ? 'hsl(222 33% 15%)' : 'hsl(210 40% 98%)',
          padding: '8px 16px',
          borderRadius: 4,
        },
        buttonBack: {
            color: theme === 'dark' ? 'hsl(210 40% 98%)' : '#000',
            padding: '8px 16px',
        },
        buttonSkip: {
            color: theme === 'dark' ? 'hsl(210 40% 98%)' : '#000',
            padding: '8px 16px',
        }
      }}
    />
  );
};

export default DashboardTour;
